import { BaseChartStyle } from "./BaseChartStyle";

class ColourChartStyle extends BaseChartStyle {
    get selectedCurrentLineColour() { return 'green'; }
    get selectedCustomLineColour() { return '#ac0000'; }
    get selectedExpirationLineColour() { return '#020202'; }

    get selectedCurrentLineType() { return 'dotted'; }
    get selectedCustomLineType() { return 'dashed'; }
    get selectedExpirationLineType() { return 'solid'; }

    get comparedCurrentLineColour() { return '#444444'; }
    get comparedCustomLineColour() { return '#444444'; }
    get comparedExpirationLineColour() { return '#444444'; }

    get underlyingLineColour() { return '#6E7079'; }
    get zeroBalanceLineColour() { return '#6E7079'; }
    get trendLineColour() { return '#6E7079'; }

    get comparedCurrentLineType() { return 'dotted'; }
    get comparedCustomLineType() { return 'dashed'; }
    get comparedExpirationLineType() { return 'solid'; }

    get deltaColour() { return '#444444'; }
    get styleFontWeight() { return 'regular'; }
    get styleFontSize() { return '13px'; }
    
    get trendLineType() { return 'solid'; }
    get trendLineWidth() { return 1; }

    get outTrendAreaColour() { return 'rgba(186,186,186,0.2)'; }
    get tradeSessionBalanceLineColour() { return '#670000'; }

    get selectedLineWidth() { return 1.75; }
    get comparedLineWidth() { return 1; }

    get impliedVolatilityLineColour() { return 'darkblue'; }
    get impliedVolatilityLineType() { return 'solid'; }
    get impliedVolatilityLineWidth() { return 3; }
}

export const colourChartStyle = new ColourChartStyle();
